import api from './api';

export const getAttestations = (dealId) =>
  api.get(`/api/deals/${dealId}/attestation`).then(r => r.data);

export const createAttestation = (dealId, payload) =>
  api.post(`/api/deals/${dealId}/attestation`, payload).then(r => r.data);

export const getAttestation = (dealId, id) =>
  api.get(`/api/deals/${dealId}/attestation/${id}`).then(r => r.data);

export const replyToAttestation = (dealId, id, content) =>
  api.post(`/api/deals/${dealId}/attestation/${id}/messages`, { content }).then(r => r.data);

export const addAttestationDocuments = (dealId, id, docIds) =>
  api.post(`/api/deals/${dealId}/attestation/${id}/documents`, { docIds }).then(r => r.data);

export const cancelAttestation = (dealId, id) =>
  api.post(`/api/deals/${dealId}/attestation/${id}/cancel`).then(r => r.data);
